export const SET_CREDIT_CARD_IS_PENDING =
  'rpb2b-react/creditcard/SET_CREDIT_CARD_IS_PENDING';
export type SET_CREDIT_CARD_IS_PENDING = typeof SET_CREDIT_CARD_IS_PENDING;

export const SET_SAVED_CREDIT_CARDS =
  'rpb2b-react/creditcard/SET_SAVED_CREDIT_CARDS';
export type SET_SAVED_CREDIT_CARDS = typeof SET_SAVED_CREDIT_CARDS;

export const SET_SELECTED_CARD = 'rpb2b-react/creditcard/SET_SELECTED_CARD';
export type SET_SELECTED_CARD = typeof SET_SELECTED_CARD;

export const SET_CREDIT_CARD_ERROR =
  'rpb2b-react/creditcard/SET_CREDIT_CARD_ERROR';
export type SET_CREDIT_CARD_ERROR = typeof SET_CREDIT_CARD_ERROR;

export const SET_CREDIT_CARD_SUCCESS =
  'rpb2b-react/creditcard/SET_CREDIT_CARD_SUCCESS';
export type SET_CREDIT_CARD_SUCCESS = typeof SET_CREDIT_CARD_SUCCESS;

export default {
  SET_CREDIT_CARD_IS_PENDING,
  SET_SAVED_CREDIT_CARDS,
  SET_SELECTED_CARD,
  SET_CREDIT_CARD_ERROR,
  SET_CREDIT_CARD_SUCCESS
};
